module.exports = "<div align=\"center\">\n  <h2>COMING SOON</h2>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/frame-management/frame-management.component.html
// module id = ../../../../../src/app/frame-management/frame-management.component.html
// module chunks = main